import React from 'react';

import Rectangle from 'recharts/es6/shape/Rectangle';

const BarBackground = ({ isSortedBy = false, ...props }) =>
    <Rectangle {...props} fill={isSortedBy ? '#ccc' : '#0000'} />;

export default BarBackground;
